import React, { Component } from "react";
import "./Navigation.css";
import { Button } from "react-bootstrap";
import { COLORS } from "../../../Theme/variables";

const pressedStyle = {
  borderColor: COLORS.secondaryLight,
  backgroundColor: COLORS.secondaryLight,
  transform: "scale(1.15, 1.15)",
};

export default class Navigation extends Component {
  render() {
    let shoppingBtn = (
      <Button
        className="roundBtn"
        id="shoppingBtn"
        variant="light"
        onClick={() => {
          this.props.switchScreenTo("shopping");
        }}
      >
        {" "}
        <img
          className="icon"
          src={require("../../../Images/Icons/shoppingCart.svg")}
          alt="shoppingIcon"
        ></img>{" "}
      </Button>
    );
    let inventoryBtn = (
      <Button
        className="roundBtn"
        id="inventoryBtn"
        variant="light"
        onClick={() => {
          this.props.switchScreenTo("inventory");
        }}
      >
        {" "}
        <img
          className="icon"
          src={require("../../../Images/Icons/Inventory.svg")}
          alt="shoppingIcon"
        ></img>{" "}
      </Button>
    );
    let trashBtn = (
      <Button
        className="roundBtn"
        id="trashBtn"
        variant="light"
        onClick={() => {
          this.props.switchScreenTo("trash");
        }}
      >
        {" "}
        <img
          className="icon"
          src={require("../../../Images/Icons/delete.svg")}
          alt="shoppingIcon"
        ></img>{" "}
      </Button>
    );

    if (this.props.currentScreen === "inventory") {
      inventoryBtn = (
        <Button
          className="roundBtn"
          id="inventoryBtn"
          variant="light"
          style={pressedStyle}
          onClick={() => {
            this.props.switchScreenTo("inventory");
          }}
        >
          {" "}
          <img
            className="icon"
            src={require("../../../Images/Icons/Inventory.svg")}
            alt="shoppingIcon"
          ></img>{" "}
        </Button>
      );
    } else if (this.props.currentScreen === "shopping") {
      shoppingBtn = (
        <Button
          className="roundBtn"
          id="shoppingBtn"
          variant="light"
          style={pressedStyle}
          onClick={() => {
            this.props.switchScreenTo("shopping");
          }}
        >
          {" "}
          <img
            className="icon"
            src={require("../../../Images/Icons/shoppingCart.svg")}
            alt="shoppingIcon"
          ></img>{" "}
        </Button>
      );
    } else {
      trashBtn = (
        <Button
          className="roundBtn"
          id="trashBtn"
          variant="light"
          style={pressedStyle}
          onClick={() => {
            this.props.switchScreenTo("trash");
          }}
        >
          {" "}
          <img
            className="icon"
            src={require("../../../Images/Icons/delete.svg")}
            alt="shoppingIcon"
          ></img>{" "}
        </Button>
      );
    }

    return (
      <div className="absoluteWrapper">
        <div className="container-fluid  navBar" style={this.props.visibility}>
          <div className="row justify-content-center">
            <div className="col-3 btnContainer">{shoppingBtn}</div>
            <div className="col-3 btnContainer">{inventoryBtn}</div>
            <div className="col-3 btnContainer">{trashBtn}</div>
          </div>
        </div>
      </div>
    );
  }
}
